'use strict';

var log = require('./log');

function add(carrier, keyValuePairs) {
  if (!carrier || !keyValuePairs) return;

  if (typeof keyValuePairs === 'string') {
    return add(carrier, keyValuePairs.split(',').filter(function (tag) {
      return tag.indexOf(':') !== -1;
    }).reduce(function (prev, next) {
      var tag = next.split(':');
      var key = tag[0];
      var value = tag.slice(1).join(':');
      prev[key] = value;
      return prev;
    }, {}));
  }

  if (Array.isArray(keyValuePairs)) {
    return keyValuePairs.forEach(function (tags) {
      return add(carrier, tags);
    });
  }

  try {
    Object.keys(keyValuePairs).forEach(function (key) {
      carrier[key] = keyValuePairs[key];
    });
  } catch (e) {
    log.error(e);
  }
}

module.exports = {
  add: add
};